import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { AppointmentService } from 'src/app/services/appointment.service';
import { PaymentService } from 'src/app/services/payment.service';

@Component({
  selector: 'app-thankyoumessageonappointment',
  templateUrl: './thankyoumessageonappointment.component.html',
  styleUrls: ['./thankyoumessageonappointment.component.css']
})
export class ThankyoumessageonappointmentComponent implements OnInit, OnDestroy {
  patientpersonalinfo : any;
  appointmentMessage: any;
  languageChangeSubscription: Subscription;
  constructor(private translateService: TranslateService,private router:Router,private _phrutilService:PhrutillsService, private service: PaymentService,private _appointmentService:AppointmentService) { 
    let info = localStorage.getItem('PatientInfo');
    if(!info){
      this.router.navigateByUrl("/home?practice_code=''");
      return;
    }
    this.patientpersonalinfo = this._phrutilService.decrypt(localStorage.getItem('PatientInfo'));
  }
  
  // GetPaymentSettings 
  ngOnInit(): void {
    this.getPaymentSettings();
    this.getCheckinSMSDetails();
    this.languageChangeSubscription = this.translateService.onLangChange.subscribe(() => {
      this.getCheckinSMSDetails();
      this._phrutilService.patientlanguage$.subscribe(language => {
        console.log("dafault " + language);
        if (language === 'es') {
          this._phrutilService.setTitle('Registro de pacientes');
        } else if (language === 'hi') {
          this._phrutilService.setTitle('रोगी पंजीकरण');
        } else if (language === 'ur') {
          this._phrutilService.setTitle('مریض کی رجسٹریشن');
        }
        else {
          this._phrutilService.setTitle('Patient Registration');
        }
      });
      // this.appointmentMessageForAll(this.smsNotificationTime);
      //this.appointmentMessageForAllElse();
      //this.appointmentMessageFor1013675();
     
    });
  }

  allowPaymentBeforeCheckin: boolean = false;
  getPaymentSettings(){
    if(!this.patientpersonalinfo ){
      return;
    }
    let data: any = {
      PracticeCode : this.patientpersonalinfo.practice_Code,
      PatientAccount : this.patientpersonalinfo .patient_Account
    };
    this.service.getPaymentSettings(data)
    .subscribe((res: any) => {
      // {"statusCode":200,"message":"success","data":{"make_Payment_Before_Checkin":"False","allow_Patient_Schedule_Appointment_Without_Provider":"False","practice_code":"1011163"}}
      if(res.statusCode == 200 && res.message == "success"){
        if(res.data.make_Payment_Before_Checkin == "True"){
          this.allowPaymentBeforeCheckin = true;
        }
        else {
          this.allowPaymentBeforeCheckin = false;
        }
      }
    }, 
    (error: any)=>{
      console.log('error: '+error);
    });
  }
  ngOnDestroy(): void {
    // Unsubscribe from language change event to prevent memory leaks
    if (this.languageChangeSubscription) {
      this.languageChangeSubscription.unsubscribe();
    }
  }
  smsNotificationTime: any;
  getCheckinSMSDetails() {
    this._appointmentService.getCheckinSMSDetails(this.patientpersonalinfo.practice_Code, this.patientpersonalinfo.patient_Account)
      .subscribe((res: any) => {
        if (res.statusCode == 200 && res.message == "success" && res.data.smS_NOTIFICATION_TIME) {
          if (this.patientpersonalinfo.practice_Code != '1013675') {
            this.smsNotificationTime = res.data.smS_NOTIFICATION_TIME;
            this.appointmentMessageForAll(res.data.smS_NOTIFICATION_TIME);

            //this.appointmentMessage = "Appointment Scheduled Successfully. You will receive the link on your cell phone or e-mail prior " + res.data.smS_NOTIFICATION_TIME + " hour(s) of the appointment to perform check-in.";
          } else {
            this.appointmentMessageFor1013675();
            // this.appointmentMessage = "You have been registered successfully.";
          }

        }
        else {
          if (this.patientpersonalinfo.practice_Code != '1013675') {
            this.appointmentMessageForAllElse();
            //this.appointmentMessage = "Appointment Scheduled Successfully.";
          }
          else {
            this.appointmentMessageFor1013675();
            //this.appointmentMessage = "You have been registered successfully.";
          }

        }
      },
        (error: any) => {
          if (this.patientpersonalinfo.practice_Code != '1013675') {
            this.appointmentMessageForAllElse();
            //this.appointmentMessage = "Appointment Scheduled Successfully.";
          }
          else {
            this.appointmentMessageFor1013675();
            // this.appointmentMessage = "You have been registered successfully.";
          }
        });
  }
  appointmentMessageForAllElse() {
    this.translateService.get('RegistrationThankYou.appointmentMessageForAllElse').subscribe((translation: string) => {
      this.appointmentMessage = translation;
    });
  }
  appointmentMessageFor1013675() {
    this.translateService.get('RegistrationThankYou.appointmentMessageFor1013675').subscribe((translation: string) => {
      this.appointmentMessage = translation;
    });
  }
  appointmentMessageForAll(time:any) {
    let appointmentMessagepart1: string;
    let appointmentMessagepart2: string;

    this.translateService.get('RegistrationThankYou.appointmentMessageForAllPart1').subscribe((translation1: string) => {
      appointmentMessagepart1 = translation1;

      this.translateService.get('RegistrationThankYou.appointmentMessageForAllPart2').subscribe((translation2: string) => {
        appointmentMessagepart2 = translation2;

        this.appointmentMessage = appointmentMessagepart1 + time + appointmentMessagepart2;
      });
    });
  }
  paynow()
  {
    //this.router.navigateByUrl("/payment-overview");
    this.router.navigate(['/payment'], {queryParams: {NewPatient:'yes'}, replaceUrl: true});
  }
}
